import type { ReportType } from '../reports-page-types/report-type';
import { REPORT_TYPES } from '../reports-page-types/report-type';

export const CSV_CUSTOMERS_CONTRACTS_FILENAME = 'customers contracts';
export const CSV_CUSTOMER_REVENUE_FILENAME = 'Rev. analysis actual & forecast';

export const REPORTS_WITH_DISABLED_ACTIONS: ReportType[] = [REPORT_TYPES.ALL_REPORTS];
